export enum STATUS {
  NOT_YET,
  DOING,
  DONE,
}

export enum LIQUIDITY_MINING_MODAL_TYPE {
  STAKE,
  STAKING,
  STAKED,
  REDEEM,
  REDEEMING,
  REDEEMED,
  CLAIMING,
  CLAIMED,
  EXITING,
  EXITED,
  NONE,
}
